import { forwardRef } from 'react';
import styles from '../AuthModal/AuthModal.module.css';

const LoadingButton = forwardRef(({
  children,
  loading = false,
  loadingText = 'Loading',
  disabled = false,
  className = '',
  variant = 'primary', // 'primary', 'secondary', 'social'
  onClick,
  type = 'button',
  showSpinner = true,
  showLoadingText = true,
  ...props
}, ref) => {
  const isDisabled = disabled || loading;

  const getButtonClass = () => {
    let baseClass = '';

    switch (variant) {
      case 'primary':
        baseClass = styles.primaryButton;
        break;
      case 'secondary':
        baseClass = styles.primaryButton; // Can be customized for secondary style
        break;
      case 'social':
        baseClass = styles.socialButton;
        break;
      default:
        baseClass = styles.primaryButton;
    }

    const loadingClass = loading ? styles.loading : '';

    return `${baseClass} ${loadingClass} ${className}`.trim();
  };

  const handleClick = (event) => {
    if (isDisabled) {
      event.preventDefault();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  const renderContent = () => {
    if (loading && showLoadingText) {
      return (
        <span>{loadingText}</span>
      );
    }

    return children;
  };

  return (
    <button
      ref={ref}
      type={type}
      className={getButtonClass()}
      onClick={handleClick}
      disabled={isDisabled}
      aria-busy={loading}
      aria-disabled={isDisabled}
      {...props}
    >
      {renderContent()}
    </button>
  );
});

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
